import { Injectable } from "@angular/core";

@Injectable()
export class TenantService {
  constructor() {}

  getTenantForHostname(hostname: string): string {
    return tenantMapping.get(hostname);
  }

  getTenant(): string {
    return this.getTenantForHostname(location.hostname);
  }
}

export enum Tenant {
  HARLEM_NEXT = "harlem_next",
  ULTRA_MEDIA = "ultra_media",
}

const tenantMapping = new Map([
  ["hq.autochatbase.com", Tenant.ULTRA_MEDIA],
  ["hq.chatomatic.nl", Tenant.HARLEM_NEXT],
]);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/tenant.service.ts